import { semver } from './common';
export const isValidSemver = (version) => semver.test(version);
